import React, { useState } from "react";
import { ProgramData, ProgramType } from "../data/programData";
import { AiOutlineWarning } from "react-icons/ai";
import { googleFormEnglish } from "../constant";
import { ServiceData } from "../data/serviceData";
import { handleCheckout } from "../utils/checkout";

interface PaymentSectionProps {
  program: ProgramData | ServiceData;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({ program }) => {
  const [loading, setLoading] = useState(false);

  const onPay = async () => {
    setLoading(true);
    await handleCheckout(program.productId);
    setLoading(false);
  };

  return (
    <div className="max-w-xl mx-auto mt-10 p-4">
      <h2 className="text-3xl font-bold text-main mb-4 text-center">Complete Your Payment</h2>

      {/* Description */}
      <p className="text-gray-600 text-center mb-6">
        Proceed with the payment to start your {program.label} consulting service.
      </p>

      {/* Warning Message */}
      <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 mb-6 flex items-start gap-3">
        <AiOutlineWarning className="text-yellow-600 text-2xl flex-shrink-0" />
        <p className="text-yellow-800 text-sm leading-relaxed">
          Please make sure to use the <strong>same name and email</strong> in the payment and the
          application form.
        </p>
      </div>

      {/* Payment Button */}
      <div className="flex flex-col items-center gap-3">
        <button
          onClick={onPay}
          disabled={loading}
          className="w-full bg-accent text-white text-center py-3 rounded-lg font-semibold hover:bg-yellow-600 transition disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? "Redirecting to Stripe…" : "Pay with Stripe"}
        </button>
      </div>

      {program.id !== ProgramType.ResumeTemplate && (
        <div className="mt-8">
          {/* Submit form message */}
          <p className="text-center text-main font-semibold mt-2 text-lg">
            After completing the payment, please submit the application form to confirm your spot.
          </p>
          <div className="flex justify-center mt-4">
            <a
              href={googleFormEnglish}
              className="inline-block bg-accent text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-yellow-600 transition-colors"
            >
              Apply Now
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSection;
